import * as React from 'react';

import {CHANNEL_VALUES_FOR_TABLES} from 'nutshell-core/channels/consts';

import {StackLegacy} from 'shells/layout/stack/stack-legacy';

import type {ChannelType} from 'nutshell-graphql-types';

import {AddSourceModal} from './modals/add-source-modal';
import {EditSourceModal} from './modals/edit-source-modal';
import {useCreateSource, useDeleteSource, useUpdateSource} from './source-mutations';
import {SetupNoChannelTable} from './sources-table/setup-no-channel-table';
import {SourcesByChannelTableWrapper} from './sources-table/sources-by-channel-table-wrapper';
import type {SourceValues} from './types';

export function SourcesTablesWrapper() {
    const [addingSource, setAddingSource] = React.useState<SourceValues | null | undefined>(null);
    const [editingSource, setEditingSource] = React.useState<SourceValues | null | undefined>(null);
    const [isSaving, setIsSaving] = React.useState<boolean>(false);

    const createSource = useCreateSource();
    const updateSource = useUpdateSource();
    const deleteSource = useDeleteSource();

    const onEditClick = (input: SourceValues) => setEditingSource(input);
    const onDelete = (input: {id: string; channel: ChannelType | null | undefined}) => {
        deleteSource(input);
    };

    return (
        <>
            <StackLegacy spacing={16}>
                <SetupNoChannelTable
                    onAddClick={() => setAddingSource({channel: null})}
                    onEditClick={onEditClick}
                    onDelete={onDelete}
                />
                {CHANNEL_VALUES_FOR_TABLES.map((value) => (
                    <SourcesByChannelTableWrapper
                        key={value}
                        channel={value}
                        onAddClick={() => setAddingSource({channel: value})}
                        onEditClick={onEditClick}
                        onDelete={onDelete}
                    />
                ))}
            </StackLegacy>
            {addingSource ? (
                <AddSourceModal
                    onClose={() => {
                        setIsSaving(false);
                        setAddingSource(null);
                    }}
                    onCreateSource={(name: string, channel?: ChannelType | null) => {
                        setIsSaving(true);
                        createSource({
                            name,
                            channel,
                        }).then(() => {
                            setIsSaving(false);
                            setAddingSource(null);
                        });
                    }}
                    isSaving={isSaving}
                    initialValues={addingSource}
                />
            ) : undefined}
            {editingSource ? (
                <EditSourceModal
                    onClose={() => {
                        setIsSaving(false);
                        setEditingSource(null);
                    }}
                    onUpdateSource={(id: string, name: string, newChannel?: ChannelType | null) => {
                        setIsSaving(true);
                        updateSource({
                            id,
                            name,
                            oldChannel: editingSource.channel,
                            newChannel,
                        }).then(() => {
                            setIsSaving(false);
                            setEditingSource(null);
                        });
                    }}
                    isSaving={isSaving}
                    initialValues={editingSource}
                />
            ) : undefined}
        </>
    );
}
